import { OpCol } from "components/customAntd/DLS/OpCol/OpCol";
import { OpForm } from "components/customAntd/DLS/OpForm/OpForm";
import { OpRow } from "components/customAntd/DLS/OpRow/OpRow";
import { useTranslation } from "react-i18next";

const ReaderForm: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <OpRow gutter={16}>
                <OpCol span={12}>
                    <OpForm.Input
                        label={t('avigilonReader.form.acuId')}
                        name="acuId"
                        disabled
                    />
                </OpCol>
                <OpCol span={12}>
                    <OpForm.Input
                        label={t('avigilonReader.form.name')}
                        name="name"
                        disabled
                    />
                </OpCol>
            </OpRow>
            <OpForm.Input
                label={t('avigilonReader.form.description')}
                name="description"
                disabled
            />
            <OpForm.Input
                label={t('avigilonReader.form.status')}
                name="status"
                disabled
            />
        </>
    );
};

export default ReaderForm;
